var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-con is-grow side-menu-layout-con no-middle-align"},[_c('div',{staticClass:"is-narrow side-menu",class:_vm.cssClasses},[_vm._t("menu")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }